<template>
  <div>
    <hr>
    <!-- eslint-disable vue/require-v-for-key -->
    <!-- eslint-disable vue/no-unused-vars -->
    <b-row v-if='showManageVisitsResultsDetailPopup === false'>
      <b-col :cols='12'>
        <h3>Resultados</h3>
        <p>R/P = Realizada/Planificada | R/NP = Realizada/No planificada | P/NR = Planificada/No Realizada</p>
      </b-col>
      <b-col :cols='12'>
        <div style="max-height: 50rem;">
          <table class='table custom'>
            <thead id="head">
            <tr>
              <th class="big-col"></th>
              <th class="big-col-2"></th>
              <th v-for='week in weeksList' class='text-center big-col' colspan="4">
                Semana {{ week.numWeek }}
                <br>
                {{ week.startWeekDay.format('DD/MM/YYYY') }} - {{ week.endWeekDay.format('DD/MM/YYYY') }}
              </th>
              <th class='text-center big-col' colspan="4">Total gestor</th>
            </tr>
            <tr>
              <th class="big-col">Distribuidora</th>
              <th class="big-col-2">Gestor</th>
              <template v-for='week in weeksList'>
                <th>R/P</th>
                <th>R/NP</th>
                <th>P/NR</th>
                <th>Total</th>
              </template>

              <!-- Total por gestor -->
              <th>R/P</th>
              <th>R/NP</th>
              <th>P/NR</th>
              <th>Total</th>
            </tr>
            </thead>
            <tbody id="body">
            <template v-for="row in this.renderManagerRows(this.dataProcessed)">
              <tr v-if='row.type !== "total" '>
                <td class="zui-sticky-col big-col" v-if='row.rowSpanDistributorCell > 0'
                    :rowspan="row.rowSpanDistributorCell">{{ row.distributor }}
                </td>
                <td class="big-col-2">{{ row.manager }}</td>

                <template v-for='week in weeksList'>

                  <td>
                    <a href="#" @click="goVisitsResultsDetail([row.distributor], row.manager, [week], ['r_p'])">
                      {{ dataProcessed[row.distributor][row.manager][week.year][week.numWeek]['r_p'] }}
                    </a>
                  </td>

                  <td>
                    <a href="#" @click="goVisitsResultsDetail([row.distributor], row.manager, [week], ['r_np'])">
                      {{ dataProcessed[row.distributor][row.manager][week.year][week.numWeek]['r_np'] }}
                    </a>
                  </td>

                  <td>
                    <a href="#" @click="goVisitsResultsDetail([row.distributor], row.manager, [week], ['p_nr'])">
                      {{ dataProcessed[row.distributor][row.manager][week.year][week.numWeek]['p_nr'] }}
                    </a>
                  </td>

                  <td class="total">
                    <a href="#"
                       @click="goVisitsResultsDetail([row.distributor], row.manager, [week], ['r_p','r_np','p_nr'])">
                      {{ getManagerTotalVisitsPerWeek(week, row.distributor, row.manager, dataProcessed) }}
                    </a>
                  </td>
                </template>

                <!-- Total por gestor -->
                <td>
                  <a href="#" @click="goVisitsResultsDetail([row.distributor], row.manager, weeksList, ['r_p'])">
                    {{ getManagerTotalVisits(row.distributor, row.manager, dataProcessed, ['r_p']) }}
                  </a>
                </td>
                <td>
                  <a href="#" @click="goVisitsResultsDetail([row.distributor], row.manager, weeksList, ['r_np'])">
                    {{ getManagerTotalVisits(row.distributor, row.manager, dataProcessed, ['r_np']) }}
                  </a>
                </td>
                <td>
                  <a href="#" @click="goVisitsResultsDetail([row.distributor], row.manager, weeksList, ['p_nr'])">
                    {{ getManagerTotalVisits(row.distributor, row.manager, dataProcessed, ['p_nr']) }}
                  </a>
                </td>
                <td class="total">
                  <a href="#"
                     @click="goVisitsResultsDetail([row.distributor], row.manager, weeksList, ['r_p', 'r_np', 'p_nr'])">
                    {{ getManagerTotalVisits(row.distributor, row.manager, dataProcessed, ['r_p', 'r_np', 'p_nr']) }}
                  </a>
                </td>
              </tr>
              <tr v-else class="total">
                <td class="zui-sticky-col-3" :colspan="2">TOTAL {{ row.distributor }}</td>

                <!-- Semanal por distribuidor -->
                <template v-for='week in weeksList'>
                  <td>
                    <a href="#" @click="goVisitsResultsDetail([row.distributor], null, [week], ['r_p'])">
                      {{ getDistributorTotalVisitsPerWeek(week, row.distributor, dataProcessed, ['r_p']) }}
                    </a>
                  </td>
                  <td>
                    <a href="#" @click="goVisitsResultsDetail([row.distributor], null, [week], ['r_np'])">
                      {{ getDistributorTotalVisitsPerWeek(week, row.distributor, dataProcessed, ['r_np']) }}
                    </a>
                  </td>
                  <td>
                    <a href="#" @click="goVisitsResultsDetail([row.distributor], null, [week], ['p_nr'])">
                      {{ getDistributorTotalVisitsPerWeek(week, row.distributor, dataProcessed, ['p_nr']) }}
                    </a>
                  </td>
                  <td>
                    <a href="#"
                       @click="goVisitsResultsDetail([row.distributor], null, [week], ['r_p', 'r_np', 'p_nr'])">
                      {{
                        getDistributorTotalVisitsPerWeek(week, row.distributor, dataProcessed, ['r_p', 'r_np', 'p_nr'])
                      }}
                    </a>
                  </td>
                </template>

                <!-- Total por distribuidor -->
                <td>
                  <a href="#" @click="goVisitsResultsDetail([row.distributor], null, weeksList, ['r_p'])">
                    {{ getDistributorTotalVisits(row.distributor, dataProcessed, ['r_p']) }}
                  </a>
                </td>
                <td>
                  <a href="#" @click="goVisitsResultsDetail([row.distributor], null, weeksList, ['r_np'])">
                    {{ getDistributorTotalVisits(row.distributor, dataProcessed, ['r_np']) }}
                  </a>
                </td>
                <td>
                  <a href="#" @click="goVisitsResultsDetail([row.distributor], null, weeksList, ['p_nr'])">
                    {{ getDistributorTotalVisits(row.distributor, dataProcessed, ['p_nr']) }}
                  </a>
                </td>
                <td>
                  <a href="#"
                     @click="goVisitsResultsDetail([row.distributor], null, weeksList, ['r_p', 'r_np', 'p_nr'])">
                    {{ getDistributorTotalVisits(row.distributor, dataProcessed, ['r_p', 'r_np', 'p_nr']) }}
                  </a>
                </td>

              </tr>
            </template>
            <tr class="total">
              <td :colspan="2">TOTAL</td>

              <template v-for='week in weeksList'>
                <td>
                  <a href="#" @click="goVisitsResultsDetail(Object.keys(dataProcessed), null, [week], ['r_p'])">
                    {{ getTotalVisitsPerWeek(week, dataProcessed, ['r_p']) }}
                  </a>
                </td>
                <td>
                  <a href="#" @click="goVisitsResultsDetail(Object.keys(dataProcessed), null, [week], ['r_np'])">
                    {{ getTotalVisitsPerWeek(week, dataProcessed, ['r_np']) }}
                  </a>
                </td>
                <td>
                  <a href="#" @click="goVisitsResultsDetail(Object.keys(dataProcessed), null, [week], ['p_nr'])">
                    {{ getTotalVisitsPerWeek(week, dataProcessed, ['p_nr']) }}
                  </a>
                </td>
                <td>
                  <a href="#"
                     @click="goVisitsResultsDetail(Object.keys(dataProcessed), null, [week], ['r_p', 'r_np', 'p_nr'])">
                    {{ getTotalVisitsPerWeek(week, dataProcessed, ['r_p', 'r_np', 'p_nr']) }}
                  </a>
                </td>
              </template>

              <!-- Total -->
              <td>
                <a href="#" @click="goVisitsResultsDetail(Object.keys(dataProcessed), null, weeksList, ['r_p'])">
                  {{ getTotalVisits(dataProcessed, ['r_p']) }}
                </a>
              </td>
              <td>
                <a href="#" @click="goVisitsResultsDetail(Object.keys(dataProcessed), null, weeksList, ['r_np'])">
                  {{ getTotalVisits(dataProcessed, ['r_np']) }}
                </a>
              </td>
              <td>
                <a href="#" @click="goVisitsResultsDetail(Object.keys(dataProcessed), null, weeksList, ['p_nr'])">
                  {{ getTotalVisits(dataProcessed, ['p_nr']) }}
                </a>
              </td>
              <td>
                <a href="#"
                   @click="goVisitsResultsDetail(Object.keys(dataProcessed), null, weeksList, ['r_p', 'r_np', 'p_nr'])">
                  {{ getTotalVisits(dataProcessed, ['r_p', 'r_np', 'p_nr']) }}
                </a>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </b-col>
    </b-row>
    <b-row v-else>
      <b-col :cols='12' style="overflow:auto; max-height:50rem;">
        <ManageVisitsResultsDetail :searchCriteria='visitsResultDetailCriteria'></ManageVisitsResultsDetail>
      </b-col>
    </b-row>
  </div>
</template>

<style scoped>
.total {
  background: khaki;
}

.table {
  display: block;
}

.table tr td {
  padding: 0 0;
}

table tbody, table thead {
  display: block;
  overflow-y: auto;
}

table tbody {
  max-height: 30rem;
}

th {
  width: 50px;
  min-width: 50px;
  padding: 0 !important;
}

td {
  width: 50px;
  min-width: 50px;
}

.big-col {
  width: 200px;
  min-width: 200px;
}

.big-col-2 {
  width: 400px;
  min-width: 400px;
}
</style>

<script>
/* eslint-disable no-undef */

import Datepicker from 'vuejs-datepicker';
import Multiselect from 'vue-multiselect';
import ScrollSync from 'vue-scroll-sync';

import moment from 'moment';

import ManageVisitsResultsDetail from './ManageVisitsResultsDetail';

export default {
  name: 'ManageVisitsResults',
  props: ['data', 'group', 'inputs'],
  components: {Datepicker, ManageVisitsResultsDetail, ScrollSync},
  Multiselect,
  data () {
    return {
      visitsResultDetailCriteria: null,
      showManageVisitsResultsDetailPopup: false,
      dataProcessed: null,
      weeksList: []
    };
  },
  computed: {},
  created: function () {
    this.processData();
  },
  mounted: function () {
    $('#head, #body').on('scroll', function () {
      $('#head, #body').scrollLeft($(this).scrollLeft());
    });
  },
  methods: {

    goVisitsResultsDetail (distributors, managerName, weeks, keys) {
      let managerCode = null;
      if (managerName) {
        managerCode = ((managerName.split('(')[1]).split(')'))[0];
      }

      this.visitsResultDetailCriteria = {
        distributors: distributors,
        manager: managerCode,
        weeks: weeks,
        keys: keys,
        group: this.group
      };

      this.showManageVisitsResultsDetailPopup = true;
    },

    getManagerTotalVisits (distributorName, managerName, data, key) {
      let total = 0;
      const years = Object.keys(data[distributorName][managerName]);

      years.forEach(year => {
        const weeks = Object.keys(data[distributorName][managerName][year]);
        weeks.forEach(week => {
          const element = data[distributorName][managerName][year][week];
          key.forEach(dataKey => {
            total += element[dataKey];
          });
        });
      });

      return total;
    },
    getManagerTotalVisitsPerWeek (week, distributorName, managerName, data) {
      return Object.values(data[distributorName][managerName][week.year][week.numWeek]).reduce((total, obj) => {
        return total + obj;
      });
    },

    getDistributorTotalVisitsPerWeek (week, distributorName, data, key) {
      let total = 0;
      const managers = Object.keys(data[distributorName]);
      managers.forEach(manager => {
        key.forEach(dataKey => {
          const element = data[distributorName][manager];
          total += element[week.year][week.numWeek][dataKey];
        });
      });

      return total;
    },

    getDistributorTotalVisits (distributorName, data, key) {
      let total = 0;

      const managers = Object.keys(data[distributorName]);

      managers.forEach(manager => {
        const years = Object.keys(data[distributorName][manager]);

        years.forEach(year => {
          const weeks = Object.keys(data[distributorName][manager][year]);

          weeks.forEach(week => {
            key.forEach(dataKey => {
              total += data[distributorName][manager][year][week][dataKey];
            });
          });
        });
      });

      return total;
    },

    getTotalVisitsPerWeek (week, data, key) {
      let total = 0;

      const distributors = Object.keys(data);

      distributors.forEach(distributor => {
        const managers = Object.keys(data[distributor]);

        managers.forEach(manager => {
          key.forEach(dataKey => {
            total += data[distributor][manager][week.year][week.numWeek][dataKey];
          });
        });
      });

      return total;
    },

    getTotalVisits (data, key) {
      let total = 0;

      const distributors = Object.keys(data);

      distributors.forEach(distributor => {
        const managers = Object.keys(data[distributor]);

        managers.forEach(manager => {
          const years = Object.keys(data[distributor][manager]);

          years.forEach(year => {
            const weeks = Object.keys(data[distributor][manager][year]);

            weeks.forEach(week => {
              key.forEach(dataKey => {
                total += data[distributor][manager][year][week][dataKey];
              });
            });
          });
        });
      });

      return total;
    },

    /**
     * Método para procesar los datos recibidos de la petición realizada de obtener los registros de las visitas
     */
    processData: function () {
      let dataProcessed = {};
      let numWeeksList = {};
      let weeksList = {};

      let dateStart = moment(this.inputs.dateStart.value);
      let dateEnd = moment(this.inputs.dateEnd.value);

      // Recorremos todos los elementos obtenidos de la base de datos
      this.data.forEach(element => {
        // Recuperamos los valores del elemento actual
        let RP = element[0]; // r_p
        let RNP = element[1]; // r_np
        let PNR = element[2]; // p_nr,
        let distributor = element[3] || 'DESCONOCIDA'; // distributor
        let managerName = element[4]; // manager
        let visitDate = (element[5] !== null) ? moment(element[5]) : null; // fecha_hora_visita
        let scheduledVisitDate = (element[6] !== null) ? moment(element[6]) : null; // fecha_hora_proxima_visita

        // Inicializamos los objetos del distribuidor y del manager si aún no se han definido
        if (!(distributor in dataProcessed)) {
          dataProcessed[distributor] = {};
        }
        if (!(managerName in dataProcessed[distributor])) {
          dataProcessed[distributor][managerName] = {};
        }

        // Seleccionamos la fecha de la visita, sino existe utilizamos la fecha proxima visita
        let weekDate = visitDate || scheduledVisitDate;

        // En caso de tener definido la fecha de visita (o la de proxima visita) y esté dentro de las fechas del filtro, lo incluimos en la lista
        if (weekDate !== null && weekDate.isSameOrAfter(dateStart, 'day') && weekDate.isSameOrBefore(dateEnd, 'day')) {
          // Calculamos el "numWeek" teniendo en cuenta que utilizamos semanas customizadas (de sábado a viernes), y obteniendolo del último dia de la semana (viernes)
          // El primer dia de la semana (startWeekDay) debe ser sábado (6). Si weekDay es lunes-viernes, el inicio es el sábado anterior (-1)
          const isoStartWeekDay = (weekDate.isoWeekday() > 5) ? 6 : -1;
          const startWeekDay = weekDate.startOf('week').clone().isoWeekday(isoStartWeekDay);
          const endWeekDay = startWeekDay.clone().add(6, 'days');
          const numWeek = endWeekDay.isoWeek();
          const year = endWeekDay.year();

          // Comprobamos que no exista la lista de semanas para este año. Si no lo está la creamos
          if (!(year in numWeeksList)) {
            numWeeksList[year] = [];
            weeksList[year] = {};
          }

          // Comprobamos que no exista la lista de esta semana. Si no lo está la creamos
          if (!numWeeksList[year].includes(numWeek)) {
            numWeeksList[year].push(numWeek);
            weeksList[year][numWeek] = {
              startWeekDay: startWeekDay,
              endWeekDay: endWeekDay,
              numWeek: numWeek,
              year: year
            };
          }

          // Inicializamos el objeto "año" si aún no se han definido para este distribuidor y manager
          if (!(year in dataProcessed[distributor][managerName])) {
            dataProcessed[distributor][managerName][year] = {};
          }

          // Definimos los valores iniciales de esta combinación distribuidor-manager-año-semana, si aún no estaba definido
          if (!(numWeek in dataProcessed[distributor][managerName][year])) {
            dataProcessed[distributor][managerName][year][numWeek] = {'r_p': 0, 'r_np': 0, 'p_nr': 0};
          }

          // Incrementamos el número de visitas en uno para el caso que se cumpla (RP / RNP / PNR)
          if (RP) {
            dataProcessed[distributor][managerName][year][numWeek]['r_p']++;
          } else if (RNP) {
            dataProcessed[distributor][managerName][year][numWeek]['r_np']++;
          } else if (PNR) {
            dataProcessed[distributor][managerName][year][numWeek]['p_nr']++;
          }
        }
      });

      // Convertimos el diccionario en una lista
      this.weeksList = Object.values(weeksList).map(weeks => Object.values(weeks)).flat();

      // Set visits to 0 for those managers that have no data for any week
      const distributors = Object.keys(dataProcessed);

      distributors.forEach(distributor => {
        const managers = Object.keys(dataProcessed[distributor]);

        managers.forEach(manager => {
          const years = Object.keys(numWeeksList);

          years.forEach(year => {
            const numWeeks = numWeeksList[year];

            numWeeks.forEach(numWeek => {
              if (!(year in dataProcessed[distributor][manager])) {
                dataProcessed[distributor][manager][year] = {};
              }

              if (!(numWeek in dataProcessed[distributor][manager][year])) {
                dataProcessed[distributor][manager][year][numWeek] = {'r_p': 0, 'r_np': 0, 'p_nr': 0};
              }
            });
          });
        });
      });

      this.dataProcessed = dataProcessed;
    },

    renderManagerRows (dataProcessed) {
      let rows = [];

      const distributors = Object.keys(dataProcessed);

      for (let i = 0; i < distributors.length; i++) {
        const distributorName = distributors[i];

        const managers = Object.keys(dataProcessed[distributorName]);
        for (let j = 0; j < managers.length; j++) {
          const managerName = managers[j];

          let rowSpanDistributorCell = 0;
          if (j === 0) {
            rowSpanDistributorCell = managers.length;
          }

          rows.push({
            distributor: distributorName,
            manager: managerName,
            rowSpanDistributorCell: rowSpanDistributorCell
          });
        }

        rows.push({type: 'total', distributor: distributorName, manager: false, rowSpanDistributorCell: false});
      }

      return rows;
    }

  }
};
</script>



// WEBPACK FOOTER //
// src/components/Layout/CommercialManagement/ManageVisitsResults.vue